import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import { useNavigate } from 'react-router-dom';

const Rooms = () => {
    const { isSidebarOpen } = useSidebar();
    const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState('');
    const [rooms, setRooms] = useState([]);

    const [filteredRooms, setFilteredRooms] = useState(rooms);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

            const BASE_URL = process.env.REACT_APP_API_BASE_URL;


       // useEffect(() => {
        // Fetch paid bookings on mount
    //     const fetchPaidBookings = async () => {
    //         try {
    //             const response = await fetch(`${BASE_URL}/api/homebookings/paid-bookings`); // Your actual backend URL
    //             if (!response.ok) throw new Error('Failed to fetch bookings');
    //             const data = await response.json();

    //             // Assuming data is an array of bookings
    //             console.log(data)
    //             setRooms(data);
    //         } catch (error) {
    //             console.error('Error fetching bookings:', error);
    //         }
    //     };

    //     fetchPaidBookings();
    // }, []);


    useEffect(() => {
    const fetchPaidBookings = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/homebookings/paid-bookings`);
            if (!response.ok) throw new Error("Failed to fetch bookings");

            const data = await response.json();
console.log("Bookings from backend:", data);

            // Process guests (fallback if guests array is null)
            const processedData = data.map(booking => {
                const roomData = booking.room || {};
                const guests = Array.isArray(booking.guests) && booking.guests.length > 0
                    ? booking.guests
                    : generateGuestsFallback(booking.adults, booking.children);

                return {
                    ...booking,
                    room: roomData,
                    guests,
                    fullName: guests.length > 0 ? guests[0].fullName || "N/A" : "N/A"
                };
            });

            setRooms(processedData);
            console.log(processedData)
        } catch (error) {
            console.error("Error fetching bookings:", error);
        }
    };

    const generateGuestsFallback = (adults, children) => {
        const guestList = [];
        for (let i = 0; i < adults; i++) {
            guestList.push({ fullName: `Adult ${i + 1}`, age: "N/A", under12: false });
        }
        for (let i = 0; i < children; i++) {
            guestList.push({ fullName: `Child ${i + 1}`, age: "N/A", under12: true });
        }
        return guestList;

    };
    fetchPaidBookings();
}, []);



    useEffect(() => {
        const filtered = rooms.filter((room) =>
            Object.values(room).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredRooms(filtered);
        setCurrentPage(1);
    }, [searchQuery, rooms]);

    const totalPages = Math.ceil(filteredRooms.length / itemsPerPage);
    const currentData = filteredRooms.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

   
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this booking?")) return;

  try {
    const response = await fetch(`${BASE_URL}/api/homebookings/${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Failed to delete booking");
    }

    // Update UI state
    setRooms((prevRooms) => prevRooms.filter((room) => room.id !== id));
  } catch (error) {
    console.error("Error deleting booking:", error);
    alert("Something went wrong while deleting.");
  }
};

 
    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Booked Rooms</h1>
                </div>

                {/* Search */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search rooms..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                {/* Room Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Guest Name</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Check-In</th>
                                <th>Check-Out</th>
                                <th>Guests</th>
                                <th>Original Price</th>
                                <th>Discounted Price</th>
                                <th>Features</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                      <tbody>
  {currentData.length > 0 ? (
    currentData.map((room, index) => (
      <tr key={index}>
        <td>{room.roomSlug}</td>
<td>{room.fullName}</td> {/* First guest name or "N/A" */}

        <td>{room.room?.city}</td>
        <td>{room.room?.state}</td>
        <td>
  {room.checkIn &&
    new Date(room.checkIn).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })}
</td>
<td>
  {room.checkOut &&
    new Date(room.checkOut).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })}
</td>

        {/* <td>{room.guests}</td> */}
<td>
  {Array.isArray(room.guests) && room.guests.length > 0 ? (
    (() => {
      const adults = room.guests.filter(g => !g.under12).length;
      const children = room.guests.filter(g => g.under12).length;
      return `${adults} Adult${adults > 1 ? "s" : ""}, ${children} Child${children > 1 ? "ren" : ""}`;
    })()
  ) : (
    "No guests"
  )}
</td>


        <td>{room.room?.originalPrice}</td>
        <td>{room.room?.discountedPrice}</td>
        <td>{room.room?.keyFeatures || "No features available"}</td>
 {/* Added safeguard */}
        <td>
        <button className="booked-delete-btn" onClick={() => handleDelete(room.id)}>
  <i className="fa-solid fa-trash"></i>
</button>

        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="11" className="text-center">No bookings found.</td>
    </tr>
  )}
</tbody>

                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};

export default Rooms;
